import React, { Component } from "react";
import { connect } from "react-redux";
import "../../styles/estilos.css";
import "../../components/Login/login.css";
import Perfil from "../../components/Perfil/Perfil";

//import "semantic-ui-css/semantic.min.css";


class ContainerPerfil extends Component {
  // constructor(props) {
  //   super(props);
  //   this.onChangeFormulario = this.onChangeFormulario.bind(this);
  //   let usr = {
  //     usrCorreo: "",
  //     usrContrasena: ""
  //   };
  //   this.state = {
  //     usrModificado: usr,
  //     showScreens: "login",
  //     user: {},
  //     open: false
  //   };
  // }
  // show = () => this.setState({ open: true });
  // handleConfirm = () => {
  //   if (this.state.recuperar) {
  //     this.setState({ open: false, recuperar: false });
  //   } else this.setState({ open: false });
  // };

  // handleIniciarSesion = async value => {
  //   this.iniciarSesion(0);
  // };

  handleCambiarContrasenia = async value => {
    this.props.history.push({
      pathname: `/cambiar-contrasenia`
    });
  };

  // async iniciarSesion(encrypted64Login) {
  //   if (encrypted64Login === 0) {
  //     let dataLogin = {};
  //     dataLogin = {
  //       cliUsuario: this.state.usrModificado.usrCorreo,
  //       cliPassword: encriptarContrasenia(
  //         this.state.usrModificado.usrContrasena
  //       ),
  //       carHash: ""
  //     };

  //     dataLogin = JSON.stringify(dataLogin);
  //     encrypted64Login = encriptarTrama(dataLogin);
  //   }

  //   await this.props.loginUsuario(encrypted64Login);
  //   this.funcionPush();
  // }

  // funcionPush() {
  //   //if (!this.props.datosUsuario.dataUsuario.registroHasErrored) {
  //   // var params = listaCar();
  //   this.timeout1 = setTimeout(() => {
  //     if (!this.props.datosUsuario.dataUsuario.userIsLoggedIn) {
  //       if (this.props.datosUsuario.loginHasError) {
  //         console.log("Login push ", this.props.datosUsuario);
  //         // console.log("Login push ",this.props.datosUsuario)
  //         mensaje = `. Inténte de nuevo`;
  //         this.show();
  //       } else this.funcionPush();
  //     } else {
  //       window.scrollTo(0, 0);
  //       //this.props.history.goBack();
  //       this.props.history.replace("/cotizacion?accion=nuevo");
  //     }
  //   }, 500);
  //   // } else {
  //   //  mensaje = "Error al registrarse, Inténte de nuevo";
  //   //   this.show();
  //   //}
  // }

  // componentDidMount = () => { };

  // onChangeFormulario(event) {
  //   let usrs = this.state.usrModificado;
  //   switch (event.target.id) {
  //     case "Inputcorreo":
  //       usrs.usrCorreo = event.target.value;
  //       break;
  //     case "Inputcontrasena":
  //       usrs.usrContrasena = event.target.value;
  //       break;

  //     default:
  //       break;
  //   }

  //   this.setState({
  //     usrModificado: usrs,
  //     mensajeError: false,
  //     mensaje: ``
  //   });
  // }

  render() {
    //console.log("datos perfil", this.props.datosUsuario);
    return (
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">

          <Perfil
            datos={this.props.datosUsuario}
            handleCambiarContrasenia={this.handleCambiarContrasenia}
          />

        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
 
  datosUsuario: state.datosUsuarios.dataUsuario
});

export default connect(
  mapStateToProps,
  null
)(ContainerPerfil);
